import { trpc } from '../../../utils/trpc';

export function useAddPurchaseItems() {
  const { mutateAsync } = trpc.purchaseItem.createMany.useMutation();
  return { appendPurchaseItems: mutateAsync };
}
